import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';
import { ApiService } from 'src/app/services/api.service';
import { UtilService } from 'src/app/services/util/util.service';
import { DelegasiPindahModalComponent } from '../delegasi-pindah-modal/delegasi-pindah-modal.component';
import { DelegasiSplitModalComponent } from '../delegasi-split-modal/delegasi-split-modal.component';

@Component({
  selector: 'app-delegasi-pindah-detail-modal',
  templateUrl: './delegasi-pindah-detail-modal.component.html',
  styleUrls: ['./delegasi-pindah-detail-modal.component.scss'],
})
export class DelegasiPindahDetailModalComponent implements OnInit {
  group: any = {};
  rows: any[] = [];
  load = false;
  masterCheck = false;
  isIndeterminate = false;

  constructor(
    private navParams: NavParams,
    private modalController: ModalController,
    private util: UtilService,
    private api: ApiService
  ) {
    this.group = this.navParams.data?.group || {};
  }

  ngOnInit(): void {
    this.loadMembers();
  }

  get selectedRows(): any[] {
    return this.rows.filter((item) => !!item.isChecked);
  }

  get hasSelection(): boolean {
    return this.selectedRows.length > 0;
  }

  loadMembers() {
    this.load = true;
    const groupId = this.group?.lead_group_id || '';

    if (!groupId) {
      this.rows = [];
      this.load = false;
      this.util.showToast('Group ID tidak ditemukan', 'danger', 'bottom');
      return;
    }

    this.api.post('backoffice/delegasi/pindah-kelompok-list/' + groupId, {}).subscribe(
      (data: any) => {
        this.load = false;
        if (data?.error == 0) {
          const list = Array.isArray(data?.data?.rows) ? data.data.rows : [];
          const mapped = list.map((item: any) => ({
            ...item,
            lead_id: item.lead_id || '',
            lead_name: item.lead_name || '-',
            team_name: item.team_name || '-',
            register_date: item.register_date || '-',
            ro_label: this.mapRoLabel(item.ro),
            group_id: groupId,
            group_name: this.group?.group_name || '',
            isChecked: false,
          }));
          this.rows = this.dedupeByLeadId(mapped);
          this.syncMasterCheck();
        } else {
          this.rows = [];
          this.util.showToast(data?.message || 'Gagal memuat detail kelompok', 'danger', 'bottom');
        }
      },
      (error) => {
        this.load = false;
        this.rows = [];
        this.api.errorCond(error);
      }
    );
  }

  private mapRoLabel(ro: any): string {
    const value = Number(ro);
    if (!Number.isFinite(value)) {
      return '-';
    }
    if (value === 0) {
      return 'NEW';
    }
    return 'RO ' + value;
  }

  statusKontrakClass(status: any): string {
    const value = String(status || '')
      .trim()
      .toUpperCase();
    if (value === 'AKTIF') {
      return 'badge-kontrak badge-kontrak-aktif';
    }
    if (value === 'LUNAS') {
      return 'badge-kontrak badge-kontrak-lunas';
    }
    if (value === 'NON AKTIF') {
      return 'badge-kontrak badge-kontrak-tidak-aktif';
    }
    return 'badge-kontrak badge-kontrak-default';
  }

  checkMaster() {
    setTimeout(() => {
      this.rows.forEach((item) => {
        item.isChecked = this.masterCheck;
      });
      this.isIndeterminate = false;
    });
  }

  checkEvent() {
    const total = this.rows.length;
    const checked = this.selectedRows.length;
    if (checked > 0 && checked < total) {
      this.isIndeterminate = true;
      this.masterCheck = false;
    } else {
      this.isIndeterminate = false;
      this.masterCheck = checked === total && total > 0;
    }
  }

  private syncMasterCheck() {
    this.masterCheck = false;
    this.isIndeterminate = false;
  }

  trackByLeadId(_index: number, item: any): string {
    return String(item?.lead_id || _index);
  }

  private dedupeByLeadId(list: any[]): any[] {
    const seen = new Set<string>();
    const result: any[] = [];
    for (const item of list) {
      const key = String(item?.lead_id || '').trim();
      if (!key) {
        result.push(item);
        continue;
      }
      if (seen.has(key)) {
        continue;
      }
      seen.add(key);
      result.push(item);
    }
    return result;
  }

  async openSingle(row: any) {
    await this.openPindahModal(row);
  }

  async openSplitKelompok() {
    if (!this.hasSelection) {
      this.util.showToast('Pilih minimal 1 anggota', 'danger', 'bottom');
      return;
    }
    await this.openSplitModal(this.selectedRows);
  }

  private async openPindahModal(row: any) {
    document.body.classList.add('modal-confirm-open');

    const modal = await this.modalController.create({
      component: DelegasiPindahModalComponent,
      cssClass: 'wd-assignXX',
      backdropDismiss: false,
      componentProps: {
        id: JSON.stringify(row.lead_id),
        kelompok: this.group?.group_name || '',
        nama: this.group?.surveyor || '',
        lead_name: row.lead_name || '',
      },
    });

    modal.onDidDismiss().then((data) => {
      document.body.classList.remove('modal-confirm-open');
      if (data.role === 'confirm') {
        this.modalController.dismiss('', 'confirm');
      }
    });

    return await modal.present();
  }

  private async openSplitModal(selected: any[]) {
    const leadIds = selected.map((item) => item.lead_id).filter(Boolean);
    document.body.classList.add('modal-confirm-open');

    const modal = await this.modalController.create({
      component: DelegasiSplitModalComponent,
      cssClass: 'wd-assignXX',
      backdropDismiss: false,
      componentProps: {
        id: JSON.stringify(leadIds.length === 1 ? leadIds[0] : leadIds),
        kelompok: this.group?.group_name || '',
        nama: this.group?.surveyor || '',
        lead_name: selected[0]?.lead_name || '',
        biling_day: this.rows[0]?.billing_day || '',
        sales_id: this.group?.surveyor || '',
        alamat: this.group?.alamat || '',
        subdistricts_id: this.group?.subdistricts_id || '',
        rt: this.group?.rt || '',
        rw: this.group?.rw || '',
        anggota: selected,
      },
    });

    modal.onDidDismiss().then((data) => {
      document.body.classList.remove('modal-confirm-open');
      if (data.role === 'confirm') {
        this.modalController.dismiss('', 'confirm');
      }
    });

    return await modal.present();
  }

  close() {
    this.modalController.dismiss();
  }
}
